<template>
  <div class="profile-item d-flex flex-column justify-content-between"
    :class="{'hover-overlay': user.cv_link && user.cv_link !== ''}" @click="openCV(user)">
    <div class="profile-item__avatar rounded-circle">
      <img :src="user.avatar_url" :alt="user.name" />
    </div>
    <div class="text-center mt-4">
      <div class="h4 mb-1 profile-item__title">{{ user.name }}</div>
      <div class="position-relative">
        <div>{{ user.position }}</div>
      </div>
    </div>
    <div class="profile-item__info mt-4">
      <div class="profile-item__prop">
        <div class="profile-item__prop-title">
          Availability
        </div>
        <div>
          {{ user.availability.name }}
        </div>
      </div>
      <div class="profile-item__prop">
        <div class="profile-item__prop-title">
          Allocation
        </div>
        <div>
          {{ user.allocations.map((allocation) => allocation.name).join(', ') }}
        </div>
      </div>
      <div class="profile-item__prop">
        <div class="profile-item__prop-title">
          Experience
        </div>
        <div>
          {{ user.years_of_experience && user.years_of_experience !== '' ? pluralize(user.years_of_experience, "year") :
          null }}
        </div>
      </div>
      <div class="profile-item__prop">
        <div class="profile-item__prop-title">
          Seniority level
        </div>
        <div>
          {{ user.seniority_lvl.name }}
        </div>
      </div>
      <div class="profile-item__prop">
        <div class="profile-item__prop-title">
          English level
        </div>
        <div>
          {{ user.english_lvl.name }}
        </div>
      </div>
    </div>

    <div class="user-skills__list profile-item__skills mt-4">
      <div class="user-skills__item" v-for="skill in user.skills" :key="skill.id">
        <div class="user-skills-chips">
          {{ skill.name }}<span class="material-icons star ml-1">
            star
          </span> {{ skill.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },

  methods: {
    pluralize: function (count, noun) {
      return `${count} ${noun}${count !== 1 ? 's' : ''}`
    },
    openCV (user) {
      if (user.cv_link && user.cv_link !== '') {
        window.open(user.cv_link)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.profile-item {
  background-color: white;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  border-radius: 1rem;
  padding: 1.5rem 2rem;

  &__cv-link {
    display: inline-flex;
    gap: 5px;
    align-items: center;
    text-decoration: none;
    position: absolute;
    right: 0px;
    top: 0px;

    .material-icons {
      text-decoration: none;
      font-size: 14px;
      width: 14px;
      height: 14px;
    }

    &:hover {
      span:first-child {
        text-decoration: underline;
      }
    }
  }

  &__avatar {
    width: 128px;
    height: 128px;
    margin: 0 auto;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__prop {
    display: grid;
    gap: 15px;
    align-items: center;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    &-title {
      color: #3D5170;
      font-weight: bold;
    }

    &-icon {
      width: 21px;
      color: #0052cc;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: 0.9rem;
  }

  &__skills {
    padding: 0;
    min-height: auto;
  }

  button {
    background-color: #3fa52f;
    border: none;
    color: white;
    padding: 0.7rem 2.5rem;
    font-size: 1.1rem;
    border-radius: 2rem;

    &:hover {
      background-color: #218838;
    }
  }
}

@media all and (max-width: 767px) {
  .profile-item {
    padding: 1.5rem;
  }
}

.profile-item.hover-overlay {
  opacity: 1;
  transition: opacity 0.5s, background-color 0.5s;
  background-color: white;
}
.profile-item.hover-overlay:hover {
  opacity: 0.9;
  transition: opacity 0.5s, background-color 0.5s;
  cursor: pointer;
  background-color: #ececec;
}
</style>
